<template>
  <div>
    <PageTable
      :orderCode="orderCode"
      :orderType="orderType"
      :custCode="custCode"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  props: {
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    orderType: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  components: { PageTable },
}
</script>
